import React, { useEffect, useState } from "react"
import { Calendar } from 'primereact/calendar';
import { Dialog } from "primereact/dialog";
import { Button } from 'primereact/button';


const DialogCustom = (props) => {
    const [fechaInicio, setFechaInicio] = useState(null);
    const [fechaFin, setFechaFin] = useState(null);
    const [maxDateUse, setMaxDateUse] = useState(null);

    const enviarRequest = (request) => {
        props.enviarFiltroP(request)
    }


    const botonesAccion = () => {
        return (
            <div>
                <Button label="Cancelar" icon="pi pi-times" onClick={() => props.setDialog(false)} className="p-button-text" />
                <Button label="Consultar" icon="pi pi-check" onClick={() => enviarRequest({ from: "button", fechaInicio: fechaInicio, fechaFin: fechaFin})} autoFocus />
            </div>
        );
    }

    return (
        <>
            {/* <Button label="Filtro" icon="pi pi-filter-fill" onClick={() => props.setDialog(true)} /> */}
            <Dialog
                header="Filtro para Bítacora" style={{ width: '25rem' }}
                visible={props.dialog} footer={botonesAccion} onHide={() => props.setDialog(false)}
            >
                <div className="grid p-fluid">
                    <div className="col-12 ">
                        <div className="field col-12">
                            <label className="font-bold">Fecha inicio</label>
                            <Calendar
                                id="time24"
                                dateFormat="yy/mm/dd"
                                value={fechaInicio}
                                onChange={(e) => {
                                    setFechaInicio(e.value);  
                                    let maxDate = new Date(e.value); 
                                    maxDate.setFullYear(e.value.getFullYear() + 1);
                                    setMaxDateUse(maxDate)
                                }}
                                showTime
                                placeholder="--Fecha Inicio--"
                            />
                        </div>
                        <div className="field col-12">
                            <label className="font-bold">Fecha Fin</label>
                            <Calendar
                                id="time24"
                                dateFormat="yy/mm/dd"
                                value={fechaFin}
                                onChange={(e) => setFechaFin(e.value)}
                                showTime
                                placeholder="--Fecha Fin--"
                                maxDate={maxDateUse}
                            />
                        </div>
                    </div>
                </div>
                {props.mensaje && (
                    <div className="uppercase text-center font-bold text-white" style={{ background: "red" }}>
                        {props.mensaje}
                    </div>
                )}
            </Dialog>

        </>

    );

}

export default DialogCustom;